import * as React from "react"
import { Link } from "react-router-dom"
import { RoommatesForListingComponent } from "../../generated/graphql"
import Row from "../row"
import Box from "../box"
import Text from "../text"
import Avatar from "../avatar"

interface Props {
  match: {
    params: {
      id: string
    }
  }
}
interface State {}
class SingleListingRoommates extends React.PureComponent<Props, State> {
  render() {
    const { match } = this.props
    return (
      <RoommatesForListingComponent
        variables={{
          id: match.params.id
        }}
      >
        {({ error, data, loading }) => {
          if (error) {
            /* eslint-disable no-console */
            console.log(error)
            /* eslint-disable no-console */
          }
          if (loading) return <div>loading...</div>

          return (
            data &&
            data.roommatesForListing.length > 0 && (
              <Box mb={[5]} flexDirection="column">
                <Text fontSize={[5]} fontWeight={600}>
                  Looking for Roommates
                </Text>
                <Row flexWrap="wrap">
                  {data &&
                    data.roommatesForListing.map((roomie, index) => (
                      <Link
                        to={`/tenant/${roomie.seeker.id}`}
                        target="_blank"
                        key={`roomate-${index + 1}`}
                      >
                        <Avatar imageURL={roomie.seeker.avatarUrl} />
                      </Link>
                    ))}
                </Row>
              </Box>
            )
          )
        }}
      </RoommatesForListingComponent>
    )
  }
}

export default SingleListingRoommates
